import './index.scss';
import React from 'react';
import { Autocomplete } from '@material-ui/lab';
import { capitalize, TextField, Avatar, TextFieldProps, CircularProgress } from '@material-ui/core';
import { environment } from '@env';
import { translate } from '@utils';
import { DeleteRoundIcon } from '@images/icons';
import { UserEntityInterface } from '@types';
import { LangEnum } from '@enums';

interface UserAutocompleteProps {
  //TODO: Define schema type
  schema?: any;
  handleChange: (...args) => void;
  autocompleteOptions: UserEntityInterface[];
  autocompleteValue?: string;
  handleOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  closeIcon?: React.ReactNode;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  size?: TextFieldProps['size'];
  variant?: TextFieldProps['variant'];
  freeSolo?: boolean;
  isMultiple?: boolean;
  index?: number;
  forcePopupIcon?: boolean | 'auto';
  isUsersLoading?: boolean;
  lang?: LangEnum;
}

export const UserAutocomplete = ({
  freeSolo,
  placeholder,
  size,
  variant,
  schema,
  handleChange,
  autocompleteOptions,
  autocompleteValue,
  handleOnChange,
  value,
  closeIcon = <DeleteRoundIcon />,
  disabled = false,
  error = false,
  isMultiple = false,
  index,
  forcePopupIcon = false,
  isUsersLoading,
  lang,
}: UserAutocompleteProps) => {
  const { properties, inputProperties } = schema
    ? schema
    : {
        properties: { freeSolo: freeSolo },
        inputProperties: { size: size, variant: variant, placeholder: placeholder },
      };
  const url = `${environment.API_URL}public/image/`;

  const dataTestId = 'ds-autocomplete-user' + (schema?.key ? `-${schema.key}` : '');
  return (
    <Autocomplete
      {...properties}
      data-testid={dataTestId}
      className="autocomplete-user"
      disabled={disabled}
      closeIcon={closeIcon}
      value={value || null}
      onChange={(event: React.ChangeEvent<HTMLInputElement>, option: UserEntityInterface) => {
        return isMultiple ? handleChange(event, index, schema.key, option) : handleChange(option);
      }}
      options={autocompleteOptions}
      getOptionLabel={(option: UserEntityInterface) =>
        option[`fullName${capitalize(`${lang}`)}`] || ''
      }
      filterOptions={(options) => options}
      renderInput={(params) => (
        <TextField
          {...params}
          {...inputProperties}
          value={autocompleteValue}
          onChange={handleOnChange}
          error={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isUsersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(option: UserEntityInterface) => (
        <div className="autocomplete-option" key={option.id}>
          <Avatar src={`${url}${option.id}`} className="autocomplete-option__avatar" />
          <span className="autocomplete-option__name">
            {option[`fullName${capitalize(`${lang}`)}`]}
          </span>
        </div>
      )}
      loading={isUsersLoading}
      loadingText={translate('loading', lang)}
      forcePopupIcon={forcePopupIcon}
      noOptionsText={translate('no_options', lang)}
    />
  );
};
